import * as React from 'react';
import styled, { ThemeProps } from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  iconSrc: string;
  textMain: string;
  textSecondary?: string;
  alt?: string;
  smaller?: boolean;
  url: string;
  backgroundColor?: string;
}

function IconWithText({
  iconSrc,
  textMain,
  textSecondary,
  alt,
  smaller,
  url,
  backgroundColor,
}: Props) {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Icon smaller={smaller} alt={alt || ''} src={iconSrc} />
      <TextLink to={url}>
        <TextMain>{textMain}</TextMain>
        {textSecondary && <TextSecondary>{textSecondary}</TextSecondary>}
      </TextLink>
    </Wrapper>
  );
}

const TextSpan: any = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;

const Wrapper = styled(FlexRowCenter)<{ backgroundColor: string }>`
  padding: ${rem(13)} 0};
  width: 25%;
  background: ${props =>
    props.backgroundColor || '${({ theme }) => theme.colors.primary}'};
  @media only screen and (max-width: 926px){
      width: 50%;
  }
  @media only screen and (max-width: 580px){
      width: 100%;
  }
`;

const TextLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-flow: column;
  font-size: 16px/20px;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${({ theme }) => theme.colors.white};
  }
`;

const Icon = styled.img`
  color: ${({ theme }) => theme.colors.white};
  width: 23px;
  height: 24px;
  margin-right: ${({ smaller }: { smaller?: boolean }) =>
    smaller ? rem(8) : rem(12)};
`;

const TextMain = styled(TextSpan)`
  font-weight: 400;
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(1)};
`;

const TextSecondary = styled(TextSpan)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(17)};
  color: ${({ theme }) => theme.colors.black};
`;

export { IconWithText as ImitradeIconWithText };
